/// <amd-module name="VSS/Features/AvatarImagePicker/Components/FilePicker/FilePickerInput" />
import * as React from "react";
import Resources = require("VSS/Features/AvatarImagePicker/Resources");

import { format } from "VSS/Core/Util/String";
import { IFilePickerInputProps } from "../FilePicker/FilePickerInput.Props";

export class FilePickerInput extends React.Component<IFilePickerInputProps, {}> {
    private validFileExtensions: string;
    public input: HTMLInputElement;

    constructor(props: IFilePickerInputProps, context?: any) {
        super(props, context);
    }

    /**
     * @override
     */
    public render(): JSX.Element {
        let accept: string | null = null;
        if (this.props.allowedFileExtensions) {
            const fileExtensions: string[] = this.props.allowedFileExtensions.map(extension => {
                if (extension[0] !== ".") {
                    return "." + extension;
                } else {
                    return extension;
                }
            });
            accept = fileExtensions.join();
            this.validFileExtensions = fileExtensions.join(", ");
        }

        return (
            <input
                type="file"
                id="idFile"
                style={{ display: "none" }}
                ref={ref => {
                    this.input = ref;
                }}
                onChange={event => {
                    this.fileSelected(event);
                    event.target.value = "";
                }} // This is needed if we want to trigger onChange upon selecting the same file
                accept={accept}
            />
        );
    }

    private fileSelected(event: React.FormEvent<HTMLInputElement>) {
        const inputTarget: HTMLInputElement = event.target as HTMLInputElement;
        const files: FileList | null = inputTarget.files;

        let file: File | null = null;
        if (files && files.length > 0) {
            file = files.item(0);
        }

        if (!file) {
            return;
        }

        let isAllowed = false;

        let fileExtension: string | undefined = file.name.split(".").pop();
        fileExtension = "." + fileExtension;

        for (let j = 0; j < this.props.allowedFileExtensions.length; j++) {
            if (fileExtension.toLocaleLowerCase() === this.props.allowedFileExtensions[j].toLocaleLowerCase()) {
                isAllowed = true;
                break;
            }
        }

        let errorMessage = "";

        if (!isAllowed) {
            errorMessage = format(Resources.FileTypeError, this.validFileExtensions.toLocaleUpperCase());
        } else if (file.size > this.props.maximumFileSize) {
            errorMessage = Resources.FileSizeError;
        }

        const fileByteArray: number[] = [];
        let dataURL = "";

        const reader: FileReader = new FileReader();

        reader.onload = (fileReadEvent: any) => {
            if (fileReadEvent.target.readyState == FileReader.DONE) {
                dataURL = fileReadEvent.target.result;
                const base64 = dataURL.split(",")[1];
                const array = this._base64ToArrayBuffer(base64);
                for (let i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                }
            }
            this.props.onload(dataURL, fileByteArray, errorMessage);
        };

        reader.readAsDataURL(file);
    }

    private _base64ToArrayBuffer(base64: string) {
        const binary_string = window.atob(base64);
        const len = binary_string.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;
    }
}
